<template>
  <b-card
    class="processing-card"
    body-class="d-flex justify-content-center align-items-center"
  >
    <div>
      <div class="d-flex justify-content-center align-items-center">
        <b-spinner
          class="in-progress-spinner"
          label="Self Check-in Spinner"
          variant="primary"
        />
      </div>
      <div class="text-center mt-2">
        <span class="d-block text-uppercase text-semibold-black">
          In Progress
        </span>
        <span class="d-block text-color-grey custom-margin-top-8">
          Please Do Not Remove Your Card or Passport
        </span>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BCard, BSpinner } from "bootstrap-vue"
export default {
  name: "MoleculeLoadingCard",
  components: {
    BCard,
    BSpinner,
  },
}
</script>

<style lang="scss" scoped>
.processing-card {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 525px;
  width: 600px;
}

.in-progress-spinner {
  width: 5rem;
  height: 5rem;
}
</style>
